export default {
  props: [
    {
      attr: 'packageNo',
      name: '课程包ID'
    },
    {
      attr: 'consumeStatusDesc',
      name: '课程包状态'
    },
    {
      attr: 'orgName',
      name: '所属校区'
    },
    {
      attr: 'userName',
      name: '消费学生'
    },
    {
      attr: 'createTime',
      name: '消费时间',
      slot: 'createTime',
      sortable: true
    },
    {
      attr: 'courseName',
      name: '关联课程'
    },
    {
      attr: 'lessonQty',
      name: '课程包含课时数'
    },
    {
      attr: 'courseStatus',
      name: '课程状态',
      slot: 'courseStatus'
    }
  ]
}
